/**
 * Utility functions for parsing todo dueDateTime values
 * Handles both Date objects and ISO strings (from backend)
 */

/**
 * Parse a todo dueDateTime value to a Date object
 * Handles both Date objects and ISO strings (date-only or full ISO)
 */
export function parseTodoDueDate(dueDateTime: Date | string | undefined): Date | undefined {
  if (!dueDateTime) return undefined;
  
  if (dueDateTime instanceof Date) {
    // If it's already a Date, check if it was created from a UTC ISO string
    // by checking if the time is midnight UTC
    const isoString = dueDateTime.toISOString();
    if (isoString.endsWith('T00:00:00.000Z')) {
      // Extract UTC date components and create local date to avoid timezone shifts
      const year = dueDateTime.getUTCFullYear();
      const month = dueDateTime.getUTCMonth();
      const day = dueDateTime.getUTCDate();
      return new Date(year, month, day);
    }
    return dueDateTime;
  }
  
  if (typeof dueDateTime === 'string') {
    // Check if it's a date-only string (YYYY-MM-DD)
    if (dueDateTime.match(/^\d{4}-\d{2}-\d{2}$/)) {
      // Date-only string: parse as local date
      const [year, month, day] = dueDateTime.split('-').map(Number);
      return new Date(year, month - 1, day);
    } else {
      // Full ISO string: extract date components from UTC to avoid timezone shifts
      const isoDate = new Date(dueDateTime);
      const year = isoDate.getUTCFullYear();
      const month = isoDate.getUTCMonth();
      const day = isoDate.getUTCDate();
      return new Date(year, month, day);
    }
  }
  
  return undefined;
}
